import { Result } from "antd";

export default function GuestThankYouPage() {
  return (
    <div style={{ padding: 16 }}>
      <Result
        status="success"
        title="Děkujeme, že jste nám pomohli být lepší."
        subTitle="Vaše odpovědi byly úspěšně odeslány."
      />
    </div>
  );
}
